<div class="container mt-3 mx-auto">
  <div class="alert alert-info" *ngIf="!avisos || !avisos.length">
    Não foram encontrados avisos com os filtros informados.
  </div>

  <div *ngIf="avisos && avisos.length">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div class="letra-miuda">atualizado em: {{ dataHoraResultado }}</div>
      <button class="btn btn-secondary m-0" type="button" (click)="btnExportarAvisos()"
        placement="top" ngbTooltip="Exporta todas os avisos listados">
      <i class="fa fa-file"></i> Exportar Avisos</button>
    </div>
    <bn-paginacao [total]="atributosPaginacao.count"
      [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
      [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th id="col-data-criacao" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataCriacao'" [nomeAtributoExibicao]="'Data de publicação'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>                    
              <th id="col-titulo" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'titulo'" [nomeAtributoExibicao]="'Título'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-agente" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'agenteFinanceiroDestinatario'"
                  [nomeAtributoExibicao]="'Destinatário'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-tipo" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'tipo'"
                  [nomeAtributoExibicao]="'Tipo'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-ativo" scope="col" *ngIf="!perfilAgente">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'avisoAtivo'" [nomeAtributoExibicao]="'Ativo'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th scope="col" class="text-start">
                  Acões
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let aviso of avisos">
              <td>{{ aviso.dataCriacao | date: 'dd/MM/yyyy HH:mm'}}</td>
              <td>{{ aviso.titulo }}</td>
              <td>{{ nomeAgente(aviso.agenteFinanceiroDestinatario) }}</td>
              <td>{{ nomeTipoAviso(aviso.tipo) }}</td>
              <td *ngIf="!perfilAgente">{{ aviso.avisoAtivo === 'S' ? 'Sim' : 'Não'}}</td>
              <td class="text-start" id=col-acoes>
                <a [routerLink]="['/avisos', aviso.id]" >
                  <i class="fa fa-search cursor-pointer"   placement="left-top" [ngbTooltip]="podeCadastrarAviso ? 'Visualizar/Editar aviso' : 'Visualizar aviso'"></i></a>
                <a href="javascript:void(0)" (click)="desativar(aviso)" *ngIf="aviso.avisoAtivo === 'S' && podeCadastrarAviso"> 
                  <i class="fa fa-trash cursor-pointer margin-left-5"    placement="left-top" ngbTooltip="Desativar aviso"></i></a>
                <a href="javascript:void(0)" (click)="exportarAnexo(aviso)" *ngIf="aviso.nomeAnexo">
                  <i class="fa fa-download cursor-pointer margin-left-5" placement="left-top" ngbTooltip="Exportar Anexo"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </div>
</div>
